import { CardTrackingData, TrackId } from 'types/Tracking';

export const cardTrackingData = (
    trackingId: TrackId,
    pageName: string,
    cardIndex: number,
    moduleTitle: string,
    assetId: string,
    assetName,
    stripePosition?: number
): CardTrackingData => ({
    'data-event-name': 'click',
    'data-track-id': trackingId,
    'data-card-position': cardIndex + 1,
    'data-module-title': moduleTitle,
    'data-stripe-position': stripePosition,
    'data-page-name': pageName,
    'data-asset-id': assetId,
    'data-asset-name': assetName,
});
